// extracted by mini-css-extract-plugin
export default {"button":"Tabs_button__R3+L3"};